import { FormatNumberOptions, IntlFormatters } from 'react-intl';

import { Currency, JobSalary, Salary, SalaryEstimate, SalaryRange } from '@/graphql/generated';

export type SalaryValid = Omit<Salary, 'amount' | 'currency'> & { amount: number; currency: Currency };

export type SalaryEstimateValid = Omit<SalaryEstimate, 'maximum' | 'minimum' | 'currency'> & {
  maximum: number;
  minimum: number;
  currency: Currency;
};

export type SalaryRangeValid = Omit<SalaryRange, 'maximum' | 'minimum' | 'currency'> & {
  maximum: number;
  minimum: number;
  currency: Currency;
};

export const formatSalary = (formatNumber: IntlFormatters['formatNumber'], [min, max]: number[]) => {
  const options = getSalaryFormatOptions('EUR');

  return `${formatNumber(min, options)} – ${formatNumber(max, options)}`;
};

export const getSalaryFormatOptions = (currency: string): FormatNumberOptions => ({
  style: 'currency',
  currency: currency,
  minimumFractionDigits: 0,
});

export const isValidSalary = (salary?: JobSalary | null): salary is SalaryValid =>
  salary?.__typename === 'Salary' && typeof salary.amount === 'number' && !!salary.currency;

export const isValidSalaryEstimate = (salary?: JobSalary | null): salary is SalaryEstimateValid =>
  salary?.__typename === 'SalaryEstimate' &&
  typeof salary.maximum === 'number' &&
  typeof salary.minimum === 'number' &&
  !!salary.currency;

export const isValidSalaryRange = (salary?: JobSalary | null): salary is SalaryRangeValid =>
  salary?.__typename === 'SalaryRange' &&
  typeof salary.maximum === 'number' &&
  typeof salary.minimum === 'number' &&
  !!salary.currency;
